<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t('Phones.EditPopup.UploadAudioFile.Label') }}</p>
      <button
          type="button"
          class="delete"
          @click="close()"/>
    </header>
    <section class="modal-card-body" ref="uploadAudioContainer">
      <div class="upload-desc">
        {{ $t('Phones.EditPopup.UploadAudioFile.Description') }}
      </div>
      <b-field class="file is-primary" :class="{'has-name': !!file}">
        <b-upload v-model="file" class="file-label" accept="audio/*" @input="onUpload">
          <span class="file-cta">
            <b-icon class="file-icon" icon="upload"></b-icon>
            <span class="file-label">{{ $t('Phones.EditPopup.UploadAudioFile.SelectFile') }}</span>
          </span>
          <span class="file-name" v-if="file">
            {{ file.name }}
          </span>
        </b-upload>
      </b-field>
    </section>
    <footer class="modal-card-foot">
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
import { Result } from "@/models/Result";
import HelperService from "@/services/HelperService";
import PhonesApiService from "@/services/api/PhonesApiService";

@Component({})
export default class UploadAudio extends Vue {
  @Prop() readonly companyId!: number;

  file: File | null = null;

  close() {
    this.$emit("close");
  }

  onUpload(file: File) {
    let loader = this.$loading.show({
      container: this.$refs.uploadAudioContainer
    });
    PhonesApiService.uploadAudioFiles(file, this.companyId).then((result: Result) => {
      if (result.Success) {
        HelperService.showNotification(i18n.t("Phones.EditPopup.UploadAudioFile.Success").toString(), "is-success", "is-top-right", 5000);
        this.$emit("update");
      } else {
        HelperService.showError(result.Message);
      }
    }).catch((e: Error) => {
      HelperService.showError(e.message);
    }).finally(() => {
      loader.hide();
      this.close();
    });
  }
}
</script>

<style lang="scss">
.upload-desc {
  margin-bottom: 1rem;
}

html[dir="rtl"] {
  .upload {
    .icon {
      margin-right: 0;
      margin-left: 0.5rem;
    }
  }
}
</style>
